// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'conversation';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M8.438 14.063a1.125 1.125 0 0 1-1.126-1.126V7.314a1.125 1.125 0 0 1 1.125-1.125h7.876a1.125 1.125 0 0 1 1.125 1.125v5.625a1.125 1.125 0 0 1-1.125 1.124h-1.125v3.376l-3.376-3.375z' />
    <path d='m5.063 9.563-2.25 2.25V8.437H1.687A1.125 1.125 0 0 1 .563 7.313V1.687A1.125 1.125 0 0 1 1.688.562h7.875a1.125 1.125 0 0 1 1.126 1.125v2.25' />
  </g>
);

export const viewBox = '0 0 18 18';
